
function isPrivate(taskItemType) {
  return ['ReportUITemplate', 'ReportUITemplateTest'].includes(taskItemType);
}

function toODataFilter(taskItemTypes) {
  return taskItemTypes.map(type => `Type eq Enum.TaskItemType'${type}'`).join(' or ');
}

export default {
  isPrivate,
  toODataFilter,
};
